"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.authorizeCommand = void 0;var _browser = require("../utils/browser");
var _storage = require("../storage");
var _const = require("../const");
var _utils = require("../utils");


/**
 * Initiates the Authentication process for the user
 * @param config
 * @param username
 * @param encodedClientState - encoded client state - will be returned in response
 */
const authorizeCommand = (config, username, encodedClientState) => {
  const pkceKey = (0, _utils.generateRandom)(128);
  (0, _storage.setLocalStorageWithExpiration)(_const.PKCE_STORAGE_KEY, pkceKey, 300);
  const codeChallenge = (0, _utils.generateChallenge)(pkceKey);

  const qsParams = {
    codeChallenge,
    ...(username ? { [_const.QS_USERNAME]: username } : {}),
    ...(encodedClientState ? { [_const.QS_STATE]: encodedClientState } : {})
  };

  (0, _browser.launchUri)((0, _utils.buildUrlFromConfig)(config, undefined, qsParams));
};exports.authorizeCommand = authorizeCommand;